import React, { FunctionComponent, useEffect, useState } from 'react'
import { Tooltip } from 'react-tippy'

import { tooltipWrapperStyles } from './ColumnTooltip.styles'
import { ClinTheme } from '../../../../ClinTheme'

interface IColumnTooltipProps {
  children: React.ReactNode
  tooltipText: string
  additionalClass?: string
  disableOnMobile?: boolean
}

const ColumnTooltip: FunctionComponent<IColumnTooltipProps> = ({
  children,
  tooltipText,
  additionalClass = '',
  disableOnMobile
}) => {
  const [isMobile, setIsMobile] = useState<boolean>(false)

  const updateIsMobile = () => {
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    setIsMobile(width <= ClinTheme.breakpoints[2])
  }

  useEffect(() => {
    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)
    return () => {
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [])

  if (!tooltipText) {
    return <>{children}</>
  }

  const tooltipPosition =
    additionalClass === 'custom-tooltip' ? 'top' : 'bottom'

  return (
    <div className={additionalClass}>
      <div style={{ ...tooltipWrapperStyles, overflow: 'hidden' }}>
        <Tooltip
          theme="light"
          title={tooltipText}
          position={tooltipPosition}
          trigger="mouseenter"
          disabled={disableOnMobile && isMobile}
          arrow={true}
        >
          <span
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: '100%'
            }}
          >
            {children}
          </span>
        </Tooltip>
      </div>
    </div>
  )
}

export default ColumnTooltip
